export interface PhoneCountryCodeOption {
  code: string;
  name: string;
  flag: string;
}

export const phoneCountryCodes: PhoneCountryCodeOption[] = [
  { code: '+47', name: 'Norge', flag: '🇳🇴' },
  { code: '+46', name: 'Sverige', flag: '🇸🇪' },
  { code: '+45', name: 'Danmark', flag: '🇩🇰' },
  { code: '+358', name: 'Finland', flag: '🇫🇮' },
  { code: '+354', name: 'Island', flag: '🇮🇸' },
  { code: '+44', name: 'UK', flag: '🇬🇧' },
  { code: '+1', name: 'USA/Canada', flag: '🇺🇸' },
  { code: '+49', name: 'Tyskland', flag: '🇩🇪' },
  { code: '+33', name: 'Frankrike', flag: '🇫🇷' },
  { code: '+34', name: 'Spania', flag: '🇪🇸' },
];


